import React, { useState, useContext } from 'react';
import { Form, Input, Button, Typography, Card, Modal } from "antd";
import {
  UserOutlined,
  LockOutlined,
  ExclamationCircleOutlined,
  LoginOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { LanguageContext } from "../LanguageContext";

const { Title, Text } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const { language, setLanguage, translations } = useContext(LanguageContext);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://json-configrator-api.root.myoctoopidev.com/Auth/Login",
        values
      );

      if (response.data?.success) {
        const { token, role, id } = response.data.data;
        localStorage.setItem("authToken", token);
        localStorage.setItem("userId", id);

        if (role === true) {
          navigate("/userdashboard");
        } else {
          navigate("/adminuserrolecontrol");
        }
      } else {
        setErrorMessage(translations[language].grisbasarısızz);
        setErrorModalVisible(true);
      }
    } catch (error) {
      console.error("Login error:", error);
      setErrorMessage(translations[language].birhataolustu);
      setErrorModalVisible(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        backgroundColor: '#001529',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      {/* Header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '12px 32px',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <span style={{ color: '#fff', fontSize: 18, fontWeight: 600 }}>
          {translations[language].layoutTitle}
        </span>
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          style={{
            background: 'rgba(255,255,255,0.12)',
            border: '1px solid rgba(255,255,255,0.25)',
            borderRadius: 6,
            color: '#fff',
            padding: '6px 10px',
            fontSize: 14,
            cursor: 'pointer',
            outline: 'none',
          }}
        >
          <option value="tr" style={{ color: '#000', background: '#fff' }}>Türkçe</option>
          <option value="en" style={{ color: '#000', background: '#fff' }}>English</option>
          <option value="de" style={{ color: '#000', background: '#fff' }}>Deutsch</option>
        </select>
      </div>

      {/* Centered content */}
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Card
        style={{
          width: 420,
          borderRadius: 16,
          boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
          border: 'none',
          overflow: 'hidden',
        }}
        bodyStyle={{ padding: '40px 36px' }}
      >
        {/* Logo & Başlık */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px auto',
              boxShadow: '0 8px 24px rgba(24, 144, 255, 0.4)',
            }}
          >
            <LoginOutlined style={{ fontSize: 32, color: '#fff' }} />
          </div>
          <Title
            level={3}
            style={{
              margin: 0,
              fontSize: 24,
              fontWeight: 700,
              color: '#262626',
            }}
          >
            {translations[language].sgy}
          </Title>
          <Text style={{ color: '#8c8c8c', fontSize: 14 }}>
            Octoopi JSON Configurator
          </Text>
        </div>

        {/* Form */}
        <Form name="login" layout="vertical" onFinish={onFinish} size="large">
          <Form.Item
            label={<span style={{ fontWeight: 500, color: '#262626' }}>{translations[language].sgy}</span>}
            name="email"
            rules={[
              { required: true, message: translations[language].lutfengecerlimail },
              { type: 'email', message: translations[language].gecerlibiremail },
            ]}
          >
            <Input
              prefix={<UserOutlined style={{ color: '#bfbfbf' }} />}
              placeholder="ornek@domain.com"
              style={{ borderRadius: 8, height: 44 }}
            />
          </Form.Item>

          <Form.Item
            label={<span style={{ fontWeight: 500, color: '#262626' }}>{translations[language].password}</span>}
            name="password"
            rules={[{ required: true, message: translations[language].lütfengeçerlişifre }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: '#bfbfbf' }} />}
              placeholder={translations[language].password}
              style={{ borderRadius: 8, height: 44 }}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
              style={{
                height: 46,
                borderRadius: 8,
                background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                border: 'none',
                fontSize: 16,
                fontWeight: 600,
                boxShadow: '0 4px 14px rgba(24, 144, 255, 0.4)',
              }}
            >
              {translations[language].gy}
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <button
              type="button"
              onClick={() => navigate('/forgot-password')}
              style={{
                background: 'none',
                border: 'none',
                color: '#1890ff',
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: 500,
                padding: 0,
              }}
            >
              {translations[language].fp_link}
            </button>
          </div>
        </Form>
      </Card>

      {/* Hata Modal */}
      <Modal
        title={null}
        open={errorModalVisible}
        onOk={() => setErrorModalVisible(false)}
        onCancel={() => setErrorModalVisible(false)}
        okText="Tekrar Dene"
        cancelText="Kapat"
        centered
        width={420}
        okButtonProps={{
          style: {
            background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
            borderColor: '#1890ff',
            height: 40,
            borderRadius: 6,
            fontWeight: 500,
            boxShadow: '0 2px 8px rgba(24, 144, 255, 0.3)',
          },
        }}
        cancelButtonProps={{
          style: {
            borderColor: '#d9d9d9',
            color: '#595959',
            height: 40,
            borderRadius: 6,
          },
        }}
        bodyStyle={{ padding: '32px', textAlign: 'center' }}
        style={{ borderRadius: 12 }}
      >
        <div
          style={{
            background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
            borderRadius: '50%',
            width: 80,
            height: 80,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px auto',
            boxShadow: '0 8px 24px rgba(255, 107, 107, 0.3)',
          }}
        >
          <ExclamationCircleOutlined style={{ fontSize: 36, color: '#fff' }} />
        </div>
        <h3
          style={{
            fontSize: 22,
            fontWeight: 600,
            color: '#262626',
            marginBottom: 12,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          }}
        >
          {translations[language].grisbasarısızz}
        </h3>
        <p style={{ fontSize: 15, color: '#ff4d4f', fontWeight: 500, marginBottom: 8 }}>
          {errorMessage}
        </p>
        <p style={{ fontSize: 13, color: '#8c8c8c', lineHeight: 1.5, marginBottom: 0 }}>
          {translations[language].birhataolustu}
        </p>
      </Modal>
      </div>

      {/* Footer */}
      <div style={{ textAlign: 'center', padding: '16px', color: 'rgba(255,255,255,0.45)', fontSize: 13 }}>
        © 2026{' '}
        <a href="http://octoopi.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'rgba(255,255,255,0.65)' }}>
          Octoopi
        </a>{' '}
        &amp; by{' '}
        <a href="https://mertech.com.tr/" target="_blank" rel="noopener noreferrer" style={{ color: 'rgba(255,255,255,0.65)' }}>
          Mertech Electronics
        </a>
      </div>
    </div>
  );
};

export default Login;